import React from 'react'
import { Modal, Button, Empty } from 'hljd'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'

export default inject('store')(
  observer(({ store: { chatStore } }) => {
    const {
      cashPackageModalVisible,
      changeCashModalVisible,
      cashPackages = [],
      sendCashPackage
    } = chatStore
    return (
      <Modal
        title="发送红包"
        visible={cashPackageModalVisible}
        destroyOnClose={true}
        wrapClassName={Style['cash-package-modal']}
        onCancel={changeCashModalVisible}
        width={620}
        footer={
          <div className={Style.qr_modal_footer}>
            <Button type="primary" onClick={changeCashModalVisible}>
              关闭
            </Button>
          </div>
        }
      >
        {cashPackages.map((item, index) => {
          return (
            <div className={Style['big-cash-package-wrap']} key={index}>
              <div className={Style['big-cash-package']}>
                <div className={Style['head']}>
                  <p>{item.group_name}</p>
                  {/*<p>*/}
                  {/*  <span>{item.type}</span>*/}
                  {/*  <span>¥{item.value}</span>*/}
                  {/*</p>*/}
                </div>
                {/*<p className={Style['foot']}>红包</p>*/}
              </div>
              <div className={Style['big-cash-package-back']} />
              <Button
                type="primary"
                className={Style['big-cash-package-btn']}
                onClick={sendCashPackage(item)}
              >
                发送
              </Button>
            </div>
          )
        })}
        {(!cashPackages || cashPackages.length == 0) && (
          <div style={{ textAlign: 'center' }}>
            <Empty description={<span />} />
            <p style={{ color: '#999' }}>还没有红包哦，快去添加红包吧~</p>
          </div>
        )}
      </Modal>
    )
  })
)
